import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      enabledFeatures: state => state.institution.enabledFeatures
    }),
    getSubOrgTabLabel () {
      return this.getLabelFor('Employer Settings', 'Sub Organization tab', this.$t('schools'))
    },
    getSubOrgLabel () {
      return this.getLabelFor('Employer Settings', 'Sub Organization Label', this.$t('school'))
    }
  },
  methods: {
    getLabelFor (featureTitle, flagTitle, defaultLabel) {
      let feature = this.enabledFeatures && this.enabledFeatures[featureTitle]
      if (feature && feature.enabled) {
        let flags = feature.flags || []
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === flagTitle && flag.label) {
            return flag.label
          }
        }
      }
      return defaultLabel
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/job/employerSettingsFlags.js